import { Box } from '@mui/material';
import { styled, css } from '@mui/material/styles';
import { switchProp } from 'styled-tools';
import { spacing, palette, withUtility } from '../../foundation/utils.js';

let _ = t => t,
  _t,
  _t2,
  _t3;
const Content = styled(Box)(_t || (_t = _`
  width: ${0};

  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  max-width: calc(100% - ${0});
  background-color: ${0};
  outline: none;
  padding: ${0};
  display: flex;
  flex-direction: column;
  max-height: calc(100% - 32px);
  ${0}

  border-radius: 12px;
  box-shadow: 0px 16px 24px rgba(26, 28, 24, 0.16);
`), switchProp('size', {
  full: '1200px',
  large: '996px',
  medium: '588px',
  small: '384px'
}), spacing(8), palette('surface'), spacing(10), withUtility(({}, {
  overflow
}) => {
  switch (overflow) {
    case 'none':
      return css(_t2 || (_t2 = _``));
    default:
      return css(_t3 || (_t3 = _`
          overflow: auto;
        `));
  }
}));

export { Content };
